export const rollcallholidayslistdata = [
  {
    "sno": 1,
    "date": "01-01-2025",
    "type": "New Year's Day",
    "description": "Celebration of the first day of the year as per the Gregorian calendar.",
    "status": true
  },
  {
    "sno": 2,
    "date": "26-01-2025",
    "type": "Republic Day",
    "description": "Celebration of India's Constitution coming into effect.",
    "status": true
  },
  {
    "sno": 3,
    "date": "17-03-2025",
    "type": "Holi",
    "description": "The festival of colors, celebrating the arrival of spring.",
    "status": true
  },
  {
    "sno": 4,
    "date": "14-04-2025",
    "type": "Ambedkar Jayanti",
    "description": "Birth anniversary of Dr. B.R. Ambedkar, the architect of the Indian Constitution.",
    "status": true
  },
  {
    "sno": 5,
    "date": "18-04-2025",
    "type": "Good Friday",
    "description": "A Christian holiday commemorating the crucifixion of Jesus Christ.",
    "status": false
  },
  {
    "sno": 6,
    "date": "01-05-2025",
    "type": "Labour Day",
    "description": "A day honoring workers and the labor movement.",
    "status": true
  },
  {
    "sno": 7,
    "date": "15-08-2025",
    "type": "Independence Day",
    "description": "Commemorating India's independence from British rule in 1947.",
    "status": true
  },
  {
    "sno": 8,
    "date": "02-10-2025",
    "type": "Gandhi Jayanti",
    "description": "Celebrating the birth anniversary of Mahatma Gandhi.",
    "status": true
  },
  {
    "sno": 9,
    "date": "20-10-2025",
    "type": "Dussehra",
    "description": "Celebration of Lord Rama's victory over Ravana.",
    "status": false
  },
  {
    "sno": 10,
    "date": "31-10-2025",
    "type": "Diwali",
    "description": "Festival of Lights symbolizing victory of light over darkness.",
    "status": true
  },
  {
    "sno": 11,
    "date": "02-11-2025",
    "type": "Bhai Dooj",
    "description": "A festival celebrating the bond between brothers and sisters.",
    "status": false
  },
  {
    "sno": 12,
    "date": "25-12-2025",
    "type": "Christmas",
    "description": "Celebration of the birth of Jesus Christ.",
    "status": true
  }
];
